import React from "react";
import clsx from "clsx";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import { useDispatch } from "react-redux";
import { signOut } from "features/authentication/authSlice";
import { GoSignOut } from "react-icons/go";
import { useStyles } from "features/admin/styles";
import { useNavigate } from "react-router-dom";
interface AppBarProps {
  open: boolean;
  handleDrawerOpen: () => void;
}

const AppBarAdmin: React.FC<AppBarProps> = ({ open, handleDrawerOpen }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const callback = () => {
    navigate("/");
  };
  const logout = () => {
    dispatch(signOut(callback));
  };
  return (
    <AppBar
      position="absolute"
      className={clsx(classes.appBar, open && classes.appBarShift)}
    >
      <Toolbar className={classes.toolbar}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          className={classes.title}
        >
          Админ панел
        </Typography>
        <IconButton color="inherit" onClick={logout}>
          <GoSignOut color="white" size="1.5rem" />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default AppBarAdmin;
